export default __webpack_public_path__ + "c66c3d93c1b695c107368a137980c040.png";